import { axios } from '../request'

const url = 'membership_cards'

export default (app) => {
  const apiURL = app.config.globalProperties.$apiURL
  return {
    namespaced: true,
    state: {
      verifyNotFound: false,
      virifyLoading: false,
      verifyLoaded: false,
      verificationData: {},
    },
    mutations: {
      setVerificationData(state, data) {
        state.verificationData = data
      },
      verifyLoaded(state, data) {
        state.verifyLoaded = data
      },
      verifyLoading(state, data) {
        state.verifyLoading = data
      },
      verifyNotFound(state, data) {
        state.verifyNotFound = data
      },
    },
    actions: {
      get(context, id) {
        return new Promise(() => {
          axios.get(url + '/' + id).then((res) => {
            window.location.replace(apiURL + '/' + res.data.data.url)
          })
        })
      },
      getAll(context, { type, includeLetters }) {
        return new Promise((resolve) => {
          axios
            .get(`${url}?type=${type}&includeLetters=${includeLetters}`)
            .then((res) => {
              resolve(apiURL + '/' + res.data.data.url)
            })
            .catch((err) => {
              console.log(err)
            })
        })
      },
      verify(context, id) {
        context.commit('verifyLoaded', false)
        context.commit('verifyLoading', true)
        context.commit('verifyNotFound', false)
        axios
          .get(url + '/verify/' + id)
          .then((res) => {
            context.commit('setVerificationData', res.data.data)
            context.commit('verifyLoaded', true)
            context.commit('verifyLoading', false)
          })
          .catch(() => {
            context.commit('setVerificationData', {})
            context.commit('verifyLoaded', true)
            context.commit('verifyLoading', false)
            context.commit('verifyNotFound', true)
          })
      },
    },
  }
}
